module.exports = __webpack_public_path__ + "img/SMS14104-L-min.ba555ae9.png";